import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/reset.less';
// quill 富文本编辑器
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import '@/assets/styles/iconfont/iconfont.css';
//图片预览插件
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';

//引入iview
import { TimePicker } from 'view-design';
import 'view-design/dist/styles/iview.css';

import { imgFilter } from './filters/vue-filters';

require('./jslibs/verify-code.min');

Vue.prototype.bus = new Vue();

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Viewer);
Vue.component('TimePicker', TimePicker);
Vue.filter('imgMapper', imgFilter);

window.vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');